import React, { useState, useEffect, useContext } from 'react';
import { AuthUserContext, withAuthorization } from '../Session';
import AdminLayout from './AdminLayout';
import { ApiHelpers } from '../../helpers';
import { Button, Empty, Form, Skeleton, Space } from 'antd';
import { useParams, useNavigate, useLocation } from 'react-router-dom';

import { useCompany } from '../../swr';
import { useRecoilState, useSetRecoilState } from 'recoil';
import { activeRestaurantState } from '../../recoil';
import RestaurantOrders from './Restaurant/RestaurantOrders';
import Onboarding from './Onboarding';
import RestaurantStats from './Restaurant/RestaurantStats';

function RestaurantStatsHome(props) {
    // Get AuthUser ID from Firebase
    const firebaseAuthUser = useContext(AuthUserContext);
    let { restaurantId } = useParams();
    const [formRestaurant] = Form.useForm();
    const [restaurantDetails, setRestaurantDetails] = useState([]);
    const [entryFound, setEntryFound] = useState(false);
    const [activeTabKey, setActiveTabKey] = useState();
    const [isLoading, setIsLoading] = useState(false);

    const [activeRestaurant, setActiveRestaurant] = useRecoilState(activeRestaurantState);

    const { data: companyDetails, isLoading: isLoadingCompanyDetails } = useCompany('getDetails', firebaseAuthUser.uid);
    let companyIdentificationToken = null;

    if (companyDetails) {
        companyIdentificationToken = companyDetails.uniqueIdentificationToken;
    }

    const routeLocation = useLocation();

    const locationFormLayout = {
        layout: 'horizontal',
        form: formRestaurant,
        labelCol: { span: 3 },
        wrapperCol: { span: 9 },
        size: 'large',
        labelAlign: 'left',
    };
    const tailLayout = {
        wrapperCol: { offset: 3, span: 9 },
    };

    useEffect(() => {
        // Get Restaurant by Id
        setIsLoading(true);
        ApiHelpers.getRestaurantsByCode(restaurantId).then(
            (response) => {
                if (response.data.message) {
                    setEntryFound(false);
                } else {
                    setRestaurantDetails({
                        ...response.data,
                        companyIdentificationToken: companyIdentificationToken,
                    });
                    setEntryFound(true);
                }
                setIsLoading(false);
            },
            (error) => {
                console.log(error);
            }
        );
    }, [restaurantId]);

    useEffect(() => {
        if (routeLocation.hash) {
            setActiveTabKey(routeLocation.hash);
        } else setActiveTabKey('#list');
    });

    return (
        <AuthUserContext.Consumer>
            {(authUser) => (
                <AdminLayout authUser={authUser} pageTitle={restaurantDetails.title}>
                    <h2>Statistici</h2>
                    {isLoadingCompanyDetails ? (
                        <Skeleton active></Skeleton>
                    ) : companyDetails.message ? (
                        <Onboarding />
                    ) : isLoading ? (
                        <Skeleton active></Skeleton>
                    ) : entryFound === true ? (
                        activeRestaurant.subscriptionPlan !== 'Free' ? (
                            <>
                                <RestaurantStats restaurantId={restaurantId} />
                            </>
                        ) : (
                            <Empty description={<span></span>}>
                                <Space size={10} direction="vertical">
                                    <div>Functionalitatile nu sunt incluse in pachetul Free</div>
                                    <Button type="primary">Upgrade</Button>
                                </Space>
                            </Empty>
                        )
                    ) : entryFound === false ? (
                        <Onboarding step={2} />
                    ) : (
                        <Skeleton active />
                    )}
                </AdminLayout>
            )}
        </AuthUserContext.Consumer>
    );
}
const condition = (authUser) => !!authUser;
export default withAuthorization(condition)(RestaurantStatsHome);
